module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/extension-worker/extension-worker.c85de900e4dfd98bd2d6.js");
};